import { render } from "./xtx-alert.vue?vue&type=template&id=e29463a2&scoped=true"
import script from "./xtx-alert.vue?vue&type=script&lang=js"
export * from "./xtx-alert.vue?vue&type=script&lang=js"

import "./xtx-alert.vue?vue&type=style&index=0&id=e29463a2&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lot\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e29463a2"]])

export default __exports__